// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__OvE5f","input":"select_input__0ssj5","icon":"select_icon__ItLWd"};